import React from 'react';
import PropTypes from 'prop-types';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const ASSESSMENT_DATA = {
    goal: 'Goal 50',
    score: 20,
    level: 'Well Below',
};

const renderAssessmentData = isClickable =>
    Object.keys(ASSESSMENT_DATA).map((key, index) => (
        <div
            key={generateReactKey(key)}
            className={`text-container ${key} ${
                index !== 0 && isClickable ? 'clickable-assesment' : ''
            }`}
        >
            {ASSESSMENT_DATA[key]}
        </div>
    ));

renderAssessmentData.defaultProps = {
    isClickable: false,
};

renderAssessmentData.propTypes = {
    isClickable: PropTypes.bool,
};

const AssessmentSummaryCardsSection = () => (
    <div className="assesment section long-section">
        <h3 className="section-name">Benchmark Assessment Scores</h3>
        <div className="wrap box-wrap">
            <div className="assesment-column">{renderAssessmentData()}</div>
            <div className="description-column">
                <div className="text">Assessment Score</div>
                <div className="text">Performance Level</div>
            </div>
            <div className="line score-line" />
            <div className="line level-line" />
        </div>

        <div className="wrap box-wrap">
            <div className="assesment-column">{renderAssessmentData(true)}</div>
            <div className="description-column-width">
                <div className="text">Click on a score to view result details</div>
            </div>
            <div className="line click-line" />
        </div>
    </div>
);

export default AssessmentSummaryCardsSection;
